export default "__VITE_ASSET__DeJchI14__"